import * as React from "react";
import type { SVGProps } from "react";
const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={140}
    height={140}
    fill="none"
    {...props}
  >
    <mask
      id="facebook_svg__a"
      width={120}
      height={120}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <circle cx={60} cy={60} r={60} fill="#0766FF" />
    </mask>
    <g mask="url(#facebook_svg__a)">
      <circle cx={60} cy={60} r={60} fill="#0766FF" />
      <path
        fill="#fff"
        d="m84.423 82.159 3.504-19.083H67.53v-6.75c0-10.084 3.956-13.963 14.195-13.963 3.181 0 5.742.077 7.215.232V25.297c-2.792-.777-9.619-1.553-13.576-1.553-20.868 0-30.487 9.853-30.487 31.109v8.223H32v19.083h12.877v41.527a62.6 62.6 0 0 0 15.087 1.839c2.561 0 5.085-.158 7.566-.457v-42.91"
      />
    </g>
  </svg>
);
export default SvgFacebook;
